import {Api, HTTPMethod, buildExport, Endpoint} from "@next/apiconfig"
import {TApiUrlSettings} from "@next/utils"
import {SummaryType} from "models/searchApi"
import env from "../../env"
import {AGGREGATORQUERYTYPES} from "../../constants"
import {QUERY_PARAMETER_TYPE} from "../../settings"

export interface ProductApiConfig {
    method: "get" | "post" | "put" | "delete"
    aggregatorUrl: (
        apiUrlSettings: TApiUrlSettings,
    ) => (version: string, paramType: string, itemNumber: string) => string
    url: (apiUrlSettings: TApiUrlSettings) => (itemNumber?: string, type?: string) => string
    routeDefinition: string
    localEndpoint: (itemNumber?: string | number, type?: string, urlType?: string, bundlePriceLabel?: string) => string
}

const {REACT_APP_API_BASEURL, REACT_APP_SERVE_PATH_PREFIX} = env
const BUNDLE_PRICE_LABEL_TEXT = "bundlePriceLabel"

export class SearchApi implements Api {
    constructor(public baseURL: string = REACT_APP_API_BASEURL) {
        this.baseURL = baseURL
    }

    version = "v1"
    endpoints = {
        getTypeSummary: {
            routeDefinition: "/:type/:itemNumber",
            getLocalURL: (
                itemNumber: string,
                type: SummaryType,
                urlType?: string,
                bundlePriceLabel?: string,
            ): string => {
                const params = new URLSearchParams()
                if (urlType) params.append(QUERY_PARAMETER_TYPE, urlType)
                if (bundlePriceLabel) params.append(BUNDLE_PRICE_LABEL_TEXT, bundlePriceLabel)
                const query = params.toString()
                return `/${type}/${itemNumber}${query ? `?${query}` : ""}`
            },
            getRemoteURL: (itemNumber: string, type: SummaryType): string => `/${type}s/${itemNumber}`,
            method: HTTPMethod.get,
        },

        getColourwaySummary: {
            routeDefinition: "/:type/colourways/:itemNumber",
            getLocalURL: (itemNumber: string, type: SummaryType): string => `/${type}/colourways/${itemNumber}`,
            getRemoteURL: (itemNumber: string, type: SummaryType): string => `/${type}s/${itemNumber}`,
            method: HTTPMethod.get,
        },

        getProductAggregator: {
            routeDefinition: "/:type/:itemNumber",
            getLocalURL: (
                itemNumber: string,
                type: SummaryType,
                urlType?: string,
                bundlePriceLabel?: string,
            ): string => {
                const params = new URLSearchParams()
                if (urlType) params.append(QUERY_PARAMETER_TYPE, urlType)
                if (bundlePriceLabel) params.append(BUNDLE_PRICE_LABEL_TEXT, bundlePriceLabel)
                const query = params.toString()
                return `/${type}/${itemNumber}${query ? `?${query}` : ""}`
            },
            getRemoteURL: (version: string, type: SummaryType): string => AGGREGATORQUERYTYPES(version)[type],
            method: HTTPMethod.get,
        },

        getOptionsStock: {
            routeDefinition: `${REACT_APP_SERVE_PATH_PREFIX}/product-summary/options/:itemNumber`,
            getLocalURL: (itemNumber: string): string =>
                `${REACT_APP_SERVE_PATH_PREFIX}/product-summary/options/${itemNumber}`,
            getRemoteURL: (itemNumber: string): string => `/items/${itemNumber}/options`,
            method: HTTPMethod.get,
        },
    } as const
}

const searchApi = (baseUrl?: string) => new SearchApi(baseUrl)
export default (endpoint: Endpoint, baseUrl?: string) => buildExport(searchApi(baseUrl), endpoint) as ProductApiConfig
